import React from "react";
import {
  BooleanField,
  DropdownField,
  EncryptedInlineBinaryField,
  ListField,
  NumberField,
  TextField
} from "components/configurationforms";
const ConfigurationFormField = ({
  typeName,
  configField,
  configKey,
  configValue = void 0,
  dirty = false,
  autoFocus = false,
  onChange
}) => {
  const elementKey = `${typeName}-${configKey}`;
  switch (configField.type) {
    case "text":
      return /* @__PURE__ */ React.createElement(
        TextField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field: configField,
          value: configValue,
          dirty,
          onChange,
          autoFocus
        }
      );
    case "number":
      return /* @__PURE__ */ React.createElement(
        NumberField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field: configField,
          value: configValue,
          onChange,
          autoFocus
        }
      );
    case "boolean":
      return /* @__PURE__ */ React.createElement(
        BooleanField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field: configField,
          value: configValue,
          onChange,
          autoFocus
        }
      );
    case "dropdown":
      return /* @__PURE__ */ React.createElement(
        DropdownField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field: configField,
          value: configValue,
          onChange,
          autoFocus,
          addPlaceholder: true
        }
      );
    case "list":
      return /* @__PURE__ */ React.createElement(
        ListField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field: configField,
          value: configValue,
          onChange,
          autoFocus
        }
      );
    case "inline_binary":
      return /* @__PURE__ */ React.createElement(
        EncryptedInlineBinaryField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field: configField,
          value: configValue,
          dirty,
          onChange,
          autoFocus
        }
      );
    default:
      return null;
  }
};
export default ConfigurationFormField;
